


































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ExpansionPanel extends Vue {
  @Prop({
    type: String,
    default: '',
  }) title!: string;

  @Prop({
    type: Number,
    default: () => null,
  }) expanded!: number;

  clickExpand() {
    this.$emit('clickExpand');
  }
}
